<template>
<div>
  <div class="height"></div>
  <div class="header" :style="{backgroundColor:color,color:fontColor}">
    <div class="left">
      
      <slot name="left"><van-icon name="arrow-left" @click="goBack" /></slot>
    </div>
    <div class="center">
      <slot name="center"></slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name:'Hearder',
  props:{
    color:{
      default:'#F63A25'
    },
    fontColor:{
      default:'white'
    },
  },
  methods:{
    goBack(){
      this.$router.back()
    },
  }
}
</script>

<style lang="less">
.height{
  height: 4.8rem;
  width: 100vw;
}
.header{
  width: 100vw;
  height: 4.8rem;
  font-size: 1.8rem;
  color: white;
  // line-height: 4.8rem;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
      box-sizing: border-box;
  z-index: 1000;
  .left{
    width: 33%;
  }
  .center{
    text-align: center;
    width: 34%;
  }
  .right{
    width: 34%;
    font-size: 1.4rem;
    text-align: right;
  }
}
</style>